<template>
  <section class="address-list glass-panel">
    <div class="list-header">
      <div>
        <h3>解析记录</h3>
        <p>查看历史解析结果，或切换复制模式批量复制当前页。</p>
      </div>
      <div class="hf-segmented">
        <button type="button" :class="{ active: modelType }" @click="modelType = true">列表模式</button>
        <button type="button" :class="{ active: !modelType }" @click="modelType = false">复制模式</button>
      </div>
    </div>

    <div v-show="modelType">
      <div class="filter-row">
        <input class="hf-field selectInput" v-model="selectForm.phone" placeholder="请输入手机号">
        <input class="hf-field selectInput" v-model="selectForm.username" placeholder="请输入收货人">
        <select class="hf-select selectInput" v-model="selectForm.recordUserId">
          <option value="">全部记录人</option>
          <option v-for="user in userList" :key="user.id" :value="user.id">
            {{ user.userName || user.phone || user.id }}
          </option>
        </select>
        <input class="hf-field date-time-input" v-model="startTime" type="datetime-local" step="1" title="开始日期时间" aria-label="开始日期时间" @change="handleStartTimeChange">
        <input class="hf-field date-time-input" v-model="endTime" type="datetime-local" step="1" title="结束日期时间" aria-label="结束日期时间" @change="handleEndTimeChange">

        <div class="filter-actions">
          <button class="hf-btn hf-btn--primary" type="button" @click="selectResolveAddress(1, size)">搜索</button>
          <button class="hf-btn hf-btn--danger" type="button" @click="trimData()">清空</button>
        </div>
      </div>
      <div class="hf-table-wrap">
        <table class="hf-table address-table">
          <colgroup>
            <col class="col-time">
            <col class="col-name">
            <col class="col-phone">
            <col class="col-region">
            <col class="col-region">
            <col class="col-region">
            <col class="col-detail">
            <col class="col-record-user">
            <col class="col-action">
          </colgroup>
          <thead>
            <tr>
              <th>采集时间</th>
              <th>收货人</th>
              <th>手机号</th>
              <th>省</th>
              <th>市</th>
              <th>区</th>
              <th>详细地址</th>
              <th>记录人</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody v-if="tableData.length">
            <tr v-for="row in tableData" :key="row.id" :class="{ 'warning-row': !row.isSuccess }">
              <td :data-tooltip="row.createTime || null">{{ row.createTime }}</td>
              <td :data-tooltip="row.username || null">{{ row.username }}</td>
              <td :data-tooltip="row.phone || null">{{ row.phone }}</td>
              <td :data-tooltip="row.province || null">{{ row.province }}</td>
              <td :data-tooltip="row.city || null">{{ row.city }}</td>
              <td :data-tooltip="row.district || null">{{ row.district }}</td>
              <td :data-tooltip="row.detailLocation || null">{{ row.detailLocation }}</td>
              <td :data-tooltip="formatRecordUser(row) || null">{{ formatRecordUser(row) }}</td>
              <td>
                <button class="hf-btn hf-btn--text" type="button" @click="deleteById(row.id)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!tableData.length && !loading" class="hf-table-empty">暂无解析记录</div>
        <div v-if="loading" class="hf-loading">加载中...</div>
      </div>
      <div class="pagination-wrap">
        <div class="hf-pagination">
          <button class="hf-page-btn" type="button" :disabled="now <= 1" @click="findPage(now - 1)">‹</button>
          <button
            v-for="page in pageNumbers"
            :key="page"
            class="hf-page-btn"
            :class="{ active: page === now }"
            type="button"
            @click="findPage(page)"
          >{{ page }}</button>
          <button class="hf-page-btn" type="button" :disabled="now >= pageCount" @click="findPage(now + 1)">›</button>
          <select class="hf-select page-size" v-model.number="size" @change="findSize(size)">
            <option v-for="item in [10, 30, 50, 100]" :key="item" :value="item">{{ item }} 条/页</option>
          </select>
          <span>共 {{ total }} 条</span>
        </div>
      </div>
    </div>
    <div v-show="!modelType" class="copy-mode">
      <textarea class="hf-textarea input_info_address" v-model="infoAddress"></textarea>
    </div>
  </section>
</template>


<script>


import { deleteNlAnalysisLocationById, pageNlAnalysisLocation} from "@/api/ResolveAddress";
import { listAdmUser } from "@/api/AdmUser";

function padTimePart(value) {
  return String(value).padStart(2, '0');
}

function getTodayDateTime(defaultTime) {
  const date = new Date();
  const dateText = [
    date.getFullYear(),
    padTimePart(date.getMonth() + 1),
    padTimePart(date.getDate())
  ].join('-');
  return `${dateText}T${defaultTime}`;
}

export default {
  name: 'ResolveAddressList',

  methods: {

    resetTimeRange() {
      this.startTime = getTodayDateTime('00:00:00');
      this.endTime = getTodayDateTime('23:59:59');
    },

    trimData(){
      this.selectForm = {
        selectTime: [],
        username: "",
        phone: "",
        recordUserId: ""
      }
      this.resetTimeRange();
      this.selectResolveAddress(this.now, this.size);
    },



    deleteById(id) {
      deleteNlAnalysisLocationById(id).then((res) => {
        if (res.code === "200") {
          this.$notify({
            title: '删除成功😁',
            message: '',
            type: 'success'
          });
        }else {
          this.$notify({
            title: '删除失败',
            message: res.message,
            type: 'error'
          });
        }
        this.selectResolveAddress(this.now, this.size);
      });


    },

    // 第n页信息
    findPage(now_page) {
      //用来处理当前页的方法,page为当前页
      this.now = now_page;
      this.showAllUserInfo(now_page, this.size);
    },
    findSize(now_size) {
      //用来处理每页条数的方法,size为当前页条数
      this.size = now_size;
      this.showAllUserInfo(this.now, now_size);
    },

    formattedDate(dateStr) {
      let date = new Date(dateStr);
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },


    // 展示所有的用户信息
    showAllUserInfo(currentPage, pageSize) {
      //异步请求显示所有数据
      currentPage = currentPage ? currentPage : this.now;
      pageSize = pageSize ? pageSize : this.size;
      this.selectResolveAddress(currentPage, pageSize);
    },

    selectResolveAddress(currentPage, pageSize) {
      this.loading = true;
      const startTime = this.normalizeDateTimeForApi(this.startTime, '00:00:00');
      const endTime = this.normalizeDateTimeForApi(this.endTime, '23:59:59');
      this.selectForm.selectTime = startTime && endTime ? [startTime, endTime] : [];
      pageNlAnalysisLocation(currentPage, pageSize,this.selectForm).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.now = Number(res.data.current || currentPage || 1);
        this.size = Number(res.data.size || pageSize || this.size);
        this.infoAddress = this.copyAddress();
      }).finally(() => {
        this.loading = false;
      });

    },
    handleStartTimeChange() {
      this.startTime = this.normalizeDateTimeForInput(this.startTime, '00:00:00');
    },
    handleEndTimeChange() {
      this.endTime = this.normalizeDateTimeForInput(this.endTime, '23:59:59');
    },
    normalizeDateTimeForInput(value, defaultTime) {
      if (!value) return '';
      const text = String(value).trim().replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        return `${text}T${defaultTime}`;
      }
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(text)) {
        return `${text}:${defaultTime.slice(6, 8)}`;
      }
      return text;
    },
    normalizeDateTimeForApi(value, defaultTime) {
      const inputValue = this.normalizeDateTimeForInput(value, defaultTime);
      return inputValue ? inputValue.replace('T', ' ') : '';
    },
    loadUserList() {
      listAdmUser().then((res) => {
        const data = res.data || [];
        const records = Array.isArray(data) ? data : (data.records || []);
        this.userList = records.map(user => ({
          ...user,
          id: String(user.id)
        }));
        if (this.tableData.length) {
          this.infoAddress = this.copyAddress();
        }
      }).catch((error) => {
        console.error('record user list load failed', error);
        this.userList = [];
      });
    },
    formatRecordUser(row) {
      if (row.recordUser) return row.recordUser;
      if (!row.recordUserId) return '';
      const user = this.userList.find(item => String(item.id) === String(row.recordUserId));
      return user ? (user.userName || user.phone || user.id) : String(row.recordUserId);
    },
    copyAddress() {
      let addressInfo = '';
      for (let i = 0; i < this.tableData.length; i++) {
        addressInfo = addressInfo
            +
            this.formattedDate(this.tableData[i].createTime)
            + '\t' +
            (this.tableData[i].username ? this.tableData[i].username : '')
            + '\t' +
            (this.tableData[i].phone ? this.tableData[i].phone : '')
            + '\t' +
            '\t' +
            (this.tableData[i].province ? this.tableData[i].province : '')
            + '\t' +
            (this.tableData[i].city ? this.tableData[i].city : '')
            + '\t' +
            (this.tableData[i].district ? this.tableData[i].district : '')
            + '\t' +
            (this.tableData[i].detailLocation ? this.tableData[i].detailLocation : '')
            + '\t' +
            this.formatRecordUser(this.tableData[i])
            + '\r\n'
      }
      return addressInfo;
    },
  },

  mounted() {
    this.loadUserList();
    this.selectResolveAddress(this.now, this.size);


  },
  data() {
    return {
      selectForm: {
        selectTime: [],
        username: "",
        phone: "",
        recordUserId: ""
      },
      userList: [],
      startTime: getTodayDateTime('00:00:00'),
      endTime: getTodayDateTime('23:59:59'),
      modelType: true,
      loading: false,
      total: 0,
      now: 1,
      size: 10,
      infoAddress: '',
      tableData: []
    }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.size));
    },
    pageNumbers() {
      const pages = [];
      const start = Math.max(1, this.now - 2);
      const end = Math.min(this.pageCount, start + 4);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
}
</script>

<style scoped>
.address-list {
  border-radius: 18px;
  padding: 18px;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.list-header h3 {
  margin: 0;
  color: #101828;
  font-size: 18px;
}

.list-header p {
  margin: 6px 0 0;
  color: #667085;
  font-size: 13px;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  margin-bottom: 14px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.selectInput {
  flex: 0 0 160px;
}

.date-time-input {
  flex: 0 0 210px;
}

.filter-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 10px;
}

.address-table {
  min-width: 1180px;
}

.address-table .col-time {
  width: 170px;
}

.address-table .col-name {
  width: 110px;
}

.address-table .col-phone {
  width: 140px;
}

.address-table .col-region {
  width: 110px;
}

.address-table .col-detail {
  width: 310px;
}

.address-table .col-record-user {
  width: 120px;
}

.address-table .col-action {
  width: 90px;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-start;
  padding-top: 14px;
  overflow-x: auto;
}

.copy-mode {
  margin-top: 12px;
}

.input_info_address {
  width: 100%;
  min-height: 520px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  line-height: 1.7;
}

.warning-row {
  background: rgba(251, 191, 36, .12);
}

.page-size {
  width: 110px;
}

@media (max-width: 760px) {
  .list-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .filter-row {
    align-items: stretch;
    flex-direction: column;
    overflow-x: visible;
  }

  .selectInput,
  .date-time-input {
    flex: auto;
    width: 100%;
  }

  .filter-actions {
    flex-wrap: wrap;
  }
}
</style>
